import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'hybse-admin-demo-markets',
  templateUrl: './demo-markets.component.html',
  styleUrls: ['./demo-markets.component.css']
})
export class DemoMarketsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/vatzcar/public_html/Exchange-NewsAdmin-Frontend/src/app/components/pages/demo-company/demo-markets/demo-markets.component.ts